<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.el-main {
  text-align: left;
  padding: 0px 20px;
}
.el-table td,
.el-table th {
  padding: 2px !important;
}
.el-table {
  font-size: 12px !important;
}
.el-table .cell {
  line-height: 20px !important;
}
.el-table .warning-row {
  background: #c6e2ff !important;
}
.el-table th {
  height: 30px !important;
  background: #ccc !important;
}
.el-table .success-row {
  background: #e1f3d8 !important;
}
.btnopt {
  color: #f56c6c !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue